import I18n from "@/i18n";

export default {
    setupTranslation: function () {
        I18n.i18next.addResources("fr", "province", {
            nova_scotia: "Nouvelle Écosse",
            quebec: "Québec",
            ontario: "Ontario",
            manitoba: "Manitoba",
            british_columbia: 'Colombie-Britannique',
            prince_edward_island: 'Île-du-Prince-Édouard',
            saskatchewan: "Saskatchewan",
            alberta: 'Alberta',
            new_found_land_and_labrador: 'Terre-Neuve-et-Labrador',
            yukon: "Yukon",
            northwest_territories: "Territoires du Nord-Ouest",
            nunavut: "Nunavut"
        });
        I18n.i18next.addResources("en", "province", {
            nova_scotia: "Nova Scotia",
            quebec: "Quebec",
            ontario: "Ontario",
            manitoba: "Manitoba",
            british_columbia: "British Columbia",
            prince_edward_island: "Prince Edward Island",
            saskatchewan: "Saskatchewan",
            alberta: 'Alberta',
            new_found_land_and_labrador: 'Newfoundland and Labrador',
            yukon: "Yukon",
            northwest_territories: "Northwest Territories",
            nunavut: "Nunavut"
        });
    },
    getForDropdown: function () {
        return [
            'nova_scotia',
            'quebec',
            'ontario',
            'manitoba',
            'british_columbia',
            'prince_edward_island',
            'saskatchewan',
            'alberta',
            'yukon',
            'northwest_territories',
            'nunavut'
        ].map((province) => {
            return {
                value: province
            };
        })
    }
}

